import { createFileRoute } from "@tanstack/react-router";
import { Link } from "@tanstack/react-router";

export const Route = createFileRoute("/(onboarding)/(documents)/sitemap")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="p-6 pb-14">
      <h1>Style PWA Routes</h1>
      <div style={{ margin: "32px 0 16px 0" }}>
        <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 12 }}>
          Main App Routes
        </h2>
        <ul style={{ lineHeight: 2 }}>
          <li>
            <Link
              to="/"
              className="block px-4 py-2 mb-2 border rounded-lg bg-white hover:bg-gray-100 transition"
            >
              Home (/)
            </Link>
          </li>
          <li>
            <Link
              to="/collections/$id"
              params={{ id: "7ed42e97-f57e-4ab8-892d-dc89f7ec238c" }}
              className="block px-4 py-2 mb-2 border rounded-lg bg-white hover:bg-gray-100 transition"
            >
              Collection Details (/collections/$id)
            </Link>
          </li>
          <li>
            <Link
              to="/search"
              search={{ q: '' }}
              className="block px-4 py-2 mb-2 border rounded-lg bg-white hover:bg-gray-100 transition"
            >
              Search
            </Link>
          </li>
          <li>
            <Link
              to="/looks/create"
              search={{ collectionId: undefined, from: undefined }}
              className="block px-4 py-2 mb-2 border rounded-lg bg-white hover:bg-gray-100 transition"
            >
              Create Look
            </Link>
          </li>
          <li>
            <Link
              to="/looks/$id"
              params={{ id: "262d353d-6ae5-454d-81ea-465cb8adeb33" }}
              className="block px-4 py-2 mb-2 border rounded-lg bg-white hover:bg-gray-100 transition"
            >
              Look Details (/looks/$id)
            </Link>
          </li>
          <li>
            <Link
              to="/products/$id"
              params={{ id: "05abc6d0-556c-47bc-97b1-640d13a36bbe" }}
              className="block px-4 py-2 mb-2 border rounded-lg bg-white hover:bg-gray-100 transition"
            >
              Product Details (/products/$id)
            </Link>
          </li>
          <li>
            <Link
              to="/users/$id"
              params={{ id: "80f1d754-0fb3-403d-9ff8-03ad8b6b9659" }}
              className="block px-4 py-2 mb-2 border rounded-lg bg-white hover:bg-gray-100 transition"
            >
              User Details (/users/$id)
            </Link>
          </li>
        </ul>
      </div>
      <div style={{ margin: "32px 0 16px 0" }}>
        <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 12 }}>
          Auth / Onboarding
        </h2>
        <ul style={{ lineHeight: 2 }}>
          <li>
            <Link
              to="/onboarding"
              className="block px-4 py-2 mb-2 border rounded-lg bg-white hover:bg-gray-100 transition"
            >
              Onboarding (/onboarding)
            </Link>
          </li>
          <li>
            <Link
              to="/login"
              className="block px-4 py-2 mb-2 border rounded-lg bg-white hover:bg-gray-100 transition"
            >
              Login (/login)
            </Link>
          </li>
          <li>
            <Link
              to="/logout"
              className="block px-4 py-2 mb-2 border rounded-lg bg-white hover:bg-gray-100 transition"
            >
              Logout (/logout)
            </Link>
          </li>
          <li>
            <Link
              to="/forgot-password/sent"
              search={{ email: "test@example.com" }}
              className="block px-4 py-2 mb-2 border rounded-lg bg-white hover:bg-gray-100 transition"
            >
              Forgot Password Sent (/forgot-password/sent)
            </Link>
          </li>
        </ul>
      </div>
      <div style={{ margin: "32px 0 16px 0" }}>
        <h2 style={{ fontSize: 20, fontWeight: 600, marginBottom: 12 }}>
          Registration Flow
        </h2>
        <ul style={{ lineHeight: 2 }}>
          <li>
            <Link
              to="/register"
              className="block px-4 py-2 mb-2 border rounded-lg bg-white hover:bg-gray-100 transition"
            >
              Register (/register)
            </Link>
          </li>
          <li>
            <Link
              to="/register/username"
              search={{ returnToPath: undefined, error: undefined }}
              className="block px-4 py-2 mb-2 border rounded-lg bg-white hover:bg-gray-100 transition"
            >
              Register Username (/register/username)
            </Link>
          </li>
          <li>
            <Link
              to="/register/account-type"
              search={{ returnToPath: undefined, error: undefined }}
              className="block px-4 py-2 mb-2 border rounded-lg bg-white hover:bg-gray-100 transition"
            >
              Register Account Type (/register/account-type)
            </Link>
          </li>
          <li>
            <Link
              to="/register/instagram"
              search={{ returnToPath: undefined, error: undefined }}
              className="block px-4 py-2 mb-2 border rounded-lg bg-white hover:bg-gray-100 transition"
            >
              Register Instagram (/register/instagram)
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
}
